import { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function PaitentIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M16.74 14a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 13.739 11q0-1.25.875-2.125A2.9 2.9 0 0 1 16.74 8q1.25 0 2.125.875.876.875.875 2.125 0 1.25-.875 2.125A2.9 2.9 0 0 1 16.74 14m-6 6v-1.9q0-.525.25-1 .25-.476.7-.75a9.3 9.3 0 0 1 2.387-1.013A10.3 10.3 0 0 1 16.739 15q1.4 0 2.663.338a9.3 9.3 0 0 1 2.387 1.012q.45.274.7.75.25.475.25 1V20zm-7-6v-2h8v2zm0-8V4h12v2zm8.1 4h-8.1V8h9q-.35.425-.563.925A6 6 0 0 0 11.839 10"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
